export default {
  FETCH_AB_TESTS: "FETCH_AB_TESTS",
  FETCH_AB_TEST: "FETCH_AB_TEST",
  CREATE_AB_TEST_INSTANCE: "CREATE_AB_TEST_INSTANCE",
  UPDATE_AB_TEST_INSTANCE: "UPDATE_AB_TEST_INSTANCE",
  SET_AB_TEST_LOADING: "SET_AB_TEST_LOADING",
  RESET_AB_TEST_LOADING: "RESET_AB_TEST_LOADING",
  SET_AB_TEST_LIVE_INSTANCE: "SET_AB_TEST_LIVE_INSTANCE",
};
